import React from 'react'
import { image } from '../../../../utils/data/baseUrl'
import { useLanguageControls } from '../../../../hooks/useLanguageControls'
import { languages } from '../../../../translations'
import { isAlfaGameActive } from '../../../../utils/game/isAlfaGameActive'
const StatsCount = React.forwardRef(function StatsCount({ targetCoins, count, type }, ref) {
  const { language } = useLanguageControls()
  const isArabic = language === languages.ar

  const formattedCount = isArabic ? `${targetCoins}/${count}` : `${count}/${targetCoins}`
  const coinImage =
    type === 'platformer' && isAlfaGameActive() ? 'games/coinAlfa.png' : 'games/coinB.png'

  return (
    <>
      {typeof count === 'number' && (
        <div className={'stats__count'}>
          <div className={'stats__count-image'}>
            <img
              className={'stats__count-image-img'}
              src={image(coinImage)}
              alt={''}
            />
          </div>
          <div className={'stats__count-wrapper'}>
            <p className={'stats__count-text'}>{formattedCount}</p>
          </div>
        </div>
      )}
    </>
  )
})
export default StatsCount
StatsCount.propTypes = {}
